import { useSelector } from 'react-redux';

// Platform-level roles (Role.organizationId IS NULL in the backend), held only
// by dex-operator admin accounts — the same pair the DSV editor pages gate on.
export const DSV_ADMIN_ROLE_NAMES = Object.freeze(['SGTradex Admin', 'Super SGTradex Admin']);

/**
 * @param {{ role?: Array<{ name?: string }> } | null | undefined} user
 * @returns {boolean} true when the user holds a platform-admin role
 */
export function isDsvAdminUser(user) {
	return Boolean(user?.role?.some((role) => DSV_ADMIN_ROLE_NAMES.includes(role?.name)));
}

/**
 * @returns {boolean} whether the logged-in user may see DSV admin surfaces
 */
export function useDsvAdmin() {
	return useSelector((state) => isDsvAdminUser(state.auth?.user));
}
